export function normalizeHex(value?: string): string {
  const match = /^#?([0-9a-f]{6})$/i.exec(String(value || '').trim());
  return match ? `#${match[1].toUpperCase()}` : '';
}

export function isSameColor(left?: string, right?: string): boolean {
  return normalizeHex(left) === normalizeHex(right);
}
